module.exports = __webpack_public_path__ + "img/scrm2img12.ab132665.png";